<template>
  <div class="contents">
    <img v-if="isValidSrc" class="h-full w-auto" :src="icon" alt="" />
    <span v-if="isSvg" class="contents" v-html="icon"></span>

    <IconsWrapper
      v-if="!isValidSrc && !isSvg"
      :icon="validatedIcon"
    ></IconsWrapper>
  </div>
</template>

<script setup lang="ts">
  import { computed } from "vue";
  import IconsWrapper from "./IconsWrapper.vue";
  const props = defineProps({
    icon: {
      type: String,
      default: "box",
    },
  });

  const isValidSrc = computed(() => {
    return props.icon.trim().startsWith("https://");
  });

  const isSvg = computed(() => {
    return (
      props.icon.trim().startsWith("<svg") &&
      props.icon.trim().endsWith("</svg>")
    );
  });

  const validatedIcon = computed(() => {
    const knownIcons = ["box", "rss"];

    if (knownIcons.includes(props.icon)) {
      return props.icon;
    }

    return "box";
  });
</script>
